// This is npm start or npm run start:mocked. Any dev server environment.
export const isDevEnv = import.meta.env.DEV;

// This is unit tests
export const isTestEnv = import.meta.env.VITEST;

// This is any npm run build (dev, test, prod), not specifically the production environment
export const isProductionEnv = import.meta.env.PROD;
